/** Keys are shared with the CMS's individual-family selector, not theme pairing IDs. */
export const richTextFontPresets = {
  Arya: "arya",
  "Cormorant Garamond": "cormorantGaramond",
  "DM Sans": "dmSans",
  Fraunces: "fraunces",
  Inter: "inter",
  Jost: "jost",
  Lato: "lato",
  Merriweather: "merriweather",
  Montserrat: "montserrat-only",
  "Playfair Display": "playfairDisplay",
  "Plus Jakarta Sans": "plusJakartaSans",
  Prata: "prata",
  "Bodoni Moda": "bodoniModa",
  Quicksand: "quicksand",
  Roboto: "standard",
  "Roboto Slab": "classic",
  "Titillium Web": "titillium_web",
  "Work Sans": "workSans",
};

export function richTextFontVariable(font: string) {
  return `--reweb-text-font-${font.toLowerCase().replace(/ /g, "-")}`;
}

/** Only these font variables are allowed in sanitized editor HTML. */
export const richTextFontStyles = new Set(
  Object.keys(richTextFontPresets).map(
    (font) => `var(${richTextFontVariable(font)}, ${font})`,
  ),
);

export function richTextFontVariables(
  familyForPreset: (preset: string) => string,
) {
  return Object.entries(richTextFontPresets)
    .map(
      ([font, preset]) =>
        `${richTextFontVariable(font)}: ${familyForPreset(preset)};`,
    )
    .join("\n");
}
